export const Copyright = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <div className="text-sm text-gray-400">
      © Copyright Bhakti Sarovar 2016 ~ {currentYear}
    </div>
  );
};